module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_CheckMarkCircle1_16"],"path":[{"$":{"d":"M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0ZM6.92,11.37,3.7,8.19,5.11,6.77l1.82,1.8,4-3.94,1.4,1.43Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_CheckMarkCircle1_16.svg
// module id = LpNj
// module chunks = 1